import InteriorDesignForm from "../component/InteriorDesignForm";

const InteriorDesignEdit = () => {
  return <InteriorDesignForm isEditMode={true} />;
};

export default InteriorDesignEdit;
